/* eslint-disable no-nested-ternary */
import format from "date-fns/format";
import { keyBy } from "lodash/fp";
import {
  ALL_DATES,
  INTEGER_KEYS,
  AppliedFilterFriendLabelMap,
  DATES,
  DROPDOWN_KEYS,
  DROPDOWN_REDUX_KEY_MAPPER,
  EXCLUDE_DATES,
  OS_DROPDOWN_KEYS,
  AppliedIntroductionFilterLabelMap,
  AppliedMemberFilterLabelMap,
  TRANSFER_DROPDOWN_REDUX_KEY_MAPPER,
  TRANSFER_OS_DROPDOWN_KEYS,
} from "../../contants";
import { ROUTES } from "../../utils/constants";
import { isEmptyObj, isOSKey, isTransferOSKey } from "../../utils/helper";

const DATE_FORMAT = "yyyy-MM-dd";
const PLUS = "plus";
const OS_LABEL = "organisationStructure";
export const POSITIONS_KEY = "positions";
export const MAINLINE_POSITION_KEY = "mainlinePositions";

export const performOperation = (value, limit, operator = PLUS) =>
  operator === PLUS ? Number(value) + limit : Number(value) - limit;

const handlePositions = (queryObject, currObj, key) => {
  const currentPositions = currObj[POSITIONS_KEY] ?? [];

  const keyValue = queryObject[key]
    ? queryObject[key].split(",").map(Number)
    : [];

  return [...currentPositions, ...keyValue];
};

const handleOS = (queryObject, currObj, key) => {
  const currentOS = currObj[OS_LABEL] ?? {};

  return Object.assign(currObj, {
    ...currentOS,
    [key]: Number(queryObject[key]),
  });
};

export const getFormattedQuery = (queryObject) =>
  !isEmptyObj(queryObject)
    ? Object.keys(queryObject).reduce((acc, currKey) => {
        let value = queryObject[currKey];
        const key = currKey === MAINLINE_POSITION_KEY ? POSITIONS_KEY : currKey;

        if (INTEGER_KEYS.includes(currKey)) {
          value = Number(queryObject[currKey]);
        } else if (ALL_DATES.includes(currKey)) {
          value = format(new Date(queryObject[currKey]), DATE_FORMAT);
        } else if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(currKey)) {
          value = handlePositions(queryObject, acc, currKey);
        } else if (OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleOS(queryObject, acc, currKey);
        } else if (TRANSFER_OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleOS(queryObject, acc, currKey);
        }
        return Object.assign(acc, {
          [key]: value,
        });
      }, {})
    : {};

export const getFilters = (queryObject, metaData, disabledOSKeys) =>
  Object.keys(queryObject).reduce((acc, curr) => {
    if (!EXCLUDE_DATES.includes(curr)) {
      // handle dates
      if (DATES.includes(curr)) {
        const key = curr.split("From")[0];
        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[key],
          value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }
      // handle dropdowns
      if (DROPDOWN_KEYS.includes(curr) || OS_DROPDOWN_KEYS.includes(curr)) {
        const pool = isOSKey(curr)
          ? metaData.organisationStructure[DROPDOWN_REDUX_KEY_MAPPER[curr]]
          : metaData[DROPDOWN_REDUX_KEY_MAPPER[curr]];

        const selectedValue = pool.find(
          (p) =>
            (p.structureId || p.divisionId || p.cityId || p.stateId) ===
            Number(queryObject[curr])
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[curr],
          value:
            selectedValue?.name ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            queryObject[curr],
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
        const positionsMap = keyBy("value", metaData.positions);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (postion) => positionsMap[postion]?.entityTitle
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[curr],
          value: positionsLabel.join(", "),
        });
        return acc;
      }

      // rest
      acc.push({
        key: curr,
        displayName: AppliedFilterFriendLabelMap[curr],
        value: queryObject[curr],
        disabled: disabledOSKeys.includes(curr),
      });
      return acc;
    }
    return acc;
  }, []);

export const getFriendFilters = (queryObject, metaData, disabledOSKeys) =>
  Object.keys(queryObject).reduce((acc, curr) => {
    if (!EXCLUDE_DATES.includes(curr)) {
      // handle dates
      if (DATES.includes(curr)) {
        const key = curr.split("From")[0];
        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[key],
          value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }
      // handle dropdowns
      if (
        DROPDOWN_KEYS.includes(curr) ||
        TRANSFER_OS_DROPDOWN_KEYS.includes(curr)
      ) {
        const pool = isTransferOSKey(curr)
          ? metaData.organisationStructure[
              TRANSFER_DROPDOWN_REDUX_KEY_MAPPER[curr]
            ]
          : metaData[TRANSFER_DROPDOWN_REDUX_KEY_MAPPER[curr]];

        const selectedValue = pool.find(
          (p) =>
            (p.structureId || p.divisionId || p.cityId || p.stateId) ===
            Number(queryObject[curr])
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[curr],
          value:
            selectedValue?.shortName ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            queryObject[curr],
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
        const positionsMap = keyBy("value", metaData.positions);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (postion) => positionsMap[postion]?.entityTitle
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[curr],
          value: positionsLabel.join(", "),
        });
        return acc;
      }

      // rest
      acc.push({
        key: curr,
        displayName: AppliedFilterFriendLabelMap[curr],
        value: queryObject[curr],
        disabled: disabledOSKeys.includes(curr),
      });
      return acc;
    }
    return acc;
  }, []);

export const getIntroductionFilters = (queryObject, metaData, disabledOSKeys) =>
  Object.keys(queryObject).reduce((acc, curr) => {
    if (!EXCLUDE_DATES.includes(curr)) {
      // handle dates
      if (DATES.includes(curr)) {
        const key = curr.split("From")[0];
        acc.push({
          key: curr,
          displayName: AppliedIntroductionFilterLabelMap[key],
          value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }
      // handle dropdowns
      if (
        DROPDOWN_KEYS.includes(curr) ||
        TRANSFER_OS_DROPDOWN_KEYS.includes(curr)
      ) {
        const pool = isTransferOSKey(curr)
          ? metaData.organisationStructure[
              TRANSFER_DROPDOWN_REDUX_KEY_MAPPER[curr]
            ]
          : metaData[TRANSFER_DROPDOWN_REDUX_KEY_MAPPER[curr]];

        const selectedValue = pool.find(
          (p) =>
            (p.structureId || p.divisionId || p.cityId || p.stateId) ===
            Number(queryObject[curr])
        );

        acc.push({
          key: curr,
          displayName: AppliedIntroductionFilterLabelMap[curr],
          value:
            selectedValue?.shortName ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            queryObject[curr],
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
        const positionsMap = keyBy("value", metaData.positions);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (postion) => positionsMap[postion]?.entityTitle
        );

        acc.push({
          key: curr,
          displayName: AppliedIntroductionFilterLabelMap[curr],
          value: positionsLabel.join(", "),
        });
        return acc;
      }

      // rest
      acc.push({
        key: curr,
        displayName: AppliedIntroductionFilterLabelMap[curr],
        value: queryObject[curr],
        disabled: disabledOSKeys.includes(curr),
      });
      return acc;
    }
    return acc;
  }, []);

export const getMemberFilters = (queryObject, metaData, disabledOSKeys) =>
  Object.keys(queryObject).reduce((acc, curr) => {
    if (!EXCLUDE_DATES.includes(curr)) {
      // handle dates
      if (DATES.includes(curr)) {
        const key = curr.split("From")[0];
        acc.push({
          key: curr,
          displayName: AppliedMemberFilterLabelMap[key],
          value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }
      // handle dropdowns
      if (
        DROPDOWN_KEYS.includes(curr) ||
        TRANSFER_OS_DROPDOWN_KEYS.includes(curr)
      ) {
        const pool = isTransferOSKey(curr)
          ? metaData.organisationStructure[
              TRANSFER_DROPDOWN_REDUX_KEY_MAPPER[curr]
            ]
          : metaData[TRANSFER_DROPDOWN_REDUX_KEY_MAPPER[curr]];

        const selectedValue = pool.find(
          (p) =>
            (p.structureId || p.divisionId || p.cityId || p.stateId) ===
            Number(queryObject[curr])
        );

        acc.push({
          key: curr,
          displayName: AppliedMemberFilterLabelMap[curr],
          value:
            selectedValue?.shortName ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            queryObject[curr],
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
        const positionsMap = keyBy("value", metaData.positions);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (postion) => positionsMap[postion]?.entityTitle
        );

        acc.push({
          key: curr,
          displayName: AppliedMemberFilterLabelMap[curr],
          value: positionsLabel.join(", "),
        });
        return acc;
      }

      // rest
      acc.push({
        key: curr,
        displayName: AppliedMemberFilterLabelMap[curr],
        value: queryObject[curr],
        disabled: disabledOSKeys.includes(curr),
      });
      return acc;
    }
    return acc;
  }, []);

export const handleDependencyFilter = (query) => {
  const updatedQueryWithOS = { ...query };
  if (!updatedQueryWithOS?.areaId) {
    delete updatedQueryWithOS.clusterId;
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.clusterId) {
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.zoneId) {
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.regionId) {
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.chapterId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.districtId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.initiatorAreaId) {
    delete updatedQueryWithOS.initiatorClusterId;
    delete updatedQueryWithOS.initiatorZoneId;
    delete updatedQueryWithOS.initiatorRegionId;
    delete updatedQueryWithOS.initiatorChapterId;
    delete updatedQueryWithOS.initiatorDistrictId;
    delete updatedQueryWithOS.initiatorBlockId;
  } else if (!updatedQueryWithOS?.initiatorClusterId) {
    delete updatedQueryWithOS.initiatorzoneId;
    delete updatedQueryWithOS.initiatorRegionId;
    delete updatedQueryWithOS.initiatorChapterId;
    delete updatedQueryWithOS.DistrictId;
    delete updatedQueryWithOS.initiatorBlockId;
  } else if (!updatedQueryWithOS?.initiatorZoneId) {
    delete updatedQueryWithOS.initiatorRegionId;
    delete updatedQueryWithOS.initiatorChapterId;
    delete updatedQueryWithOS.DistrictId;
    delete updatedQueryWithOS.initiatorBlockId;
  } else if (!updatedQueryWithOS?.initiatorRegionId) {
    delete updatedQueryWithOS.initiatorChapterId;
    delete updatedQueryWithOS.initiatorDistrictId;
    delete updatedQueryWithOS.initiatorBlockId;
  } else if (!updatedQueryWithOS?.initiatorChapterId) {
    delete updatedQueryWithOS.initiatorDistrictId;
    delete updatedQueryWithOS.initiatorBlockId;
  } else if (!updatedQueryWithOS?.initiatorDistrictId) {
    delete updatedQueryWithOS.initiatorDistrictId;
    delete updatedQueryWithOS.initiatorBlockId;
  } else if (!updatedQueryWithOS?.targetAreaId) {
    delete updatedQueryWithOS.targetClusterId;
    delete updatedQueryWithOS.targetZoneId;
    delete updatedQueryWithOS.targetRegionId;
    delete updatedQueryWithOS.targetChapterId;
    delete updatedQueryWithOS.targetDistrictId;
    delete updatedQueryWithOS.targetBlockId;
  } else if (!updatedQueryWithOS?.targetClusterId) {
    delete updatedQueryWithOS.targetZoneId;
    delete updatedQueryWithOS.targetRegionId;
    delete updatedQueryWithOS.targetChapterId;
    delete updatedQueryWithOS.targetDistrictId;
    delete updatedQueryWithOS.targetBlockId;
  } else if (!updatedQueryWithOS?.targetZoneId) {
    delete updatedQueryWithOS.targetRegionId;
    delete updatedQueryWithOS.targetChapterId;
    delete updatedQueryWithOS.targetDistrictId;
    delete updatedQueryWithOS.targetBlockId;
  } else if (!updatedQueryWithOS?.targetRegionId) {
    delete updatedQueryWithOS.targetChapterId;
    delete updatedQueryWithOS.targetDistrictId;
    delete updatedQueryWithOS.targetBlockId;
  } else if (!updatedQueryWithOS?.targetChapterId) {
    delete updatedQueryWithOS.targetDistrictId;
    delete updatedQueryWithOS.targetBlockId;
  } else if (!updatedQueryWithOS?.targetDistrictId) {
    delete updatedQueryWithOS.targetDistrictId;
    delete updatedQueryWithOS.BlockId;
  }

  // state and divisions
  if (!updatedQueryWithOS?.state) {
    delete updatedQueryWithOS.city;
  }
  if (!updatedQueryWithOS?.divisionId) {
    delete updatedQueryWithOS.subdivisionId;
  }

  return updatedQueryWithOS;
};
export const getFriendRoutePath = () => ROUTES.FRIEND_SEARCH.path;

export const getFriendTransferRequestRoutePath = () =>
  ROUTES.FRIEND_TRANSFER_REQUEST.path;

export const getIntroductionTransferRequestRoutePath = () =>
  ROUTES.INTRODUCTION_TRANSFER_REQUEST.path;

export const getMemberTransferRequestRoutePath = () =>
  ROUTES.MEMBER_REQUEST.path;
